module.exports = require("./mfe.d.ts");